<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 154.868 116.209">
    <g transform="translate(0 0)">
      <path class="cls-1" d="M69.217,124.3v12.008H57.751a3.963,3.963,0,0,0-3.951,3.951,4.249,4.249,0,0,0,3.951,3.951h63.682a3.951,3.951,0,1,0,0-7.9H109.968V124.3Z" transform="translate(-12.12 -28.002)" />
      <g id="realTimeData" transform="translate(23.862 14.565)">
        <line id="l1" class="line-style" y1="50" y2="5" transform="translate(15,5)" />
        <line id="l2" class="line-style" y1="50" y2="5" transform="translate(40,5)" />
        <line id="l3" class="line-style" y1="50" y2="5" transform="translate(65,5)" />
        <line id="l4" class="line-style" y1="50" y2="5" transform="translate(90,5)" />
      </g>
      <path class="cls-1" d="M142.859,8.057a4.1,4.1,0,0,1,4.029,4.029V86.769a4.1,4.1,0,0,1-4.029,4.029H12.086a4.1,4.1,0,0,1-4.029-4.029V12.086a4.1,4.1,0,0,1,4.029-4.029H142.859m0-8.057H12.086A12.1,12.1,0,0,0,0,12.086V86.769A12.1,12.1,0,0,0,12.086,98.855h130.7a12.1,12.1,0,0,0,12.086-12.086V12.086A11.986,11.986,0,0,0,142.859,0Z" />
    </g>
  </svg>
</template>

<script>
  import * as d3 from 'd3';
  export default {
    data(){
      return {

      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
  .line-style {
    stroke: #333;
    stroke-width: 15;
    stroke-linecap: round;
    stroke-dasharray: 45;
  }

  #l1 {
    animation: lineRun1 1.2s linear infinite;
  }

  #l2{
    animation: lineRun2 1.2s linear infinite;
  }

  #l3{
    animation: lineRun3 1.2s linear infinite;
  }

  #l4{
    animation: lineRun4 1.2s linear infinite;
  }

  @keyframes lineRun1 {
    from {
      stroke-dashoffset: 40;
    }
    7.143% {
      stroke-dashoffset: 45;
    }
    60%{
      stroke-dashoffset: 10;
    }
    to {
      stroke-dashoffset: 40;
    }
  }

  @keyframes lineRun2 {
    from {
      stroke-dashoffset: 30;
    }
    21.43%{
      stroke-dashoffset: 45;
    }
    71.43% {
      stroke-dashoffset: 10;
    }
    to {
      stroke-dashoffset: 30;
    }
  }

  @keyframes lineRun3 {
    from {
      stroke-dashoffset: 10;
    }
    50% {
      stroke-dashoffset: 45;
    }
    to{
      stroke-dashoffset: 10;
    }
  }

  @keyframes lineRun4 {
    from {
      stroke-dashoffset: 20;
    }
    35.714% {
      stroke-dashoffset: 45;
    }
    85.714% {
      stroke-dashoffset: 10;
    }
    to{
      stroke-dashoffset: 20;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/svgs/RealTimeData.vue